"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTag = void 0;
const lit_1 = require("lit");
const if_defined_js_1 = require("lit/directives/if-defined.js");
/** tag 계열이 공유하는 mm-tag 조립 규칙. tone·icon·slot 기본값 매핑은 각 시맨틱 컴포넌트가 소유한다. */
function renderTag(tone, icon, fallback) {
    return (0, lit_1.html) `
    <mm-tag tone=${tone} icon=${(0, if_defined_js_1.ifDefined)(icon)}>
      <slot>${fallback}</slot>
    </mm-tag>
  `;
}
exports.renderTag = renderTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLnV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGFnLnV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUEwQjtBQUMxQixnRUFBd0Q7QUFLeEQsMEVBQTBFO0FBQzFFLFNBQWdCLFNBQVMsQ0FBQyxJQUFhLEVBQUUsSUFBMEIsRUFBRSxRQUFrQjtJQUNyRixPQUFPLElBQUEsVUFBSSxFQUFBO21CQUNNLElBQUksU0FBUyxJQUFBLHlCQUFTLEVBQUMsSUFBSSxDQUFDO2NBQ2pDLFFBQVE7O0dBRW5CLENBQUE7QUFDSCxDQUFDO0FBTkQsOEJBTUMifQ==